// extracted by css-extract-rspack-plugin
export default {"cellWrapper":"cellWrapper-AetHL9","cellText":"cellText-gntuZy"};